import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
// import DateInputPicker from 'modules/common/components/DateInputPicker';
// import moment from 'moment';
// import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function RateModal({
  createRate,
  getRateList,
  history,
  getSingleRate,
  actualUseList,
  getActualUseList,
  ordinanceRevisionList,
  getOrdinanceRevisionList,
  type,
  updateRate,
  updateList,
  rateId,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    code: '',
    kind_of_property: '',
    sef_rate: '',
    basic_rate: '',
    actual_use_id: '',
    ordinance_revision_id: '',
    // effectivity_date: '',
  });
  const validateForm = useFormValidator(formData, {
    code: 'required',
    kind_of_property: 'required',
    sef_rate: 'required',
    basic_rate: 'required',
    actual_use_id: 'required',
    ordinance_revision_id: 'required',
    // effectivity_date: 'required',
  });

  useEffect(() => {
    getActualUseList();
    getOrdinanceRevisionList();
  }, []);

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createRate(formData, ({ data }) => {
        setModal({ isOpen: false });
        getRateList({ ordinance_revision_id: ordinanceRevisionId });
        history.push(`/rpt/land/land-settings/rates/${_.get(data, 'id')}`);
        getSingleRate(data.id);
      });
    }

    if (type === 'EDIT') {
      updateRate(rateId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getRateList({ ordinance_revision_id: ordinanceRevisionId });
        history.push(`/rpt/land/land-settings/rates/${_.get(data, 'id')}`);
        getSingleRate(data.id);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const actualUseOptions = actualUseList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const ordinanceRevisionOptions = ordinanceRevisionList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Kind of Property {validateForm.renderMessage('kind_of_property')}
            </label>
            <div>
              <Select
                options={c.KIND_OF_PROPERTY_OPTIONS}
                // styles={customStyle}
                placeholder="Select Kind of Property"
                value={
                  c.KIND_OF_PROPERTY_OPTIONS.filter(
                    (item) =>
                      _.get(formData, 'kind_of_property') ===
                      _.get(item, 'value')
                  ) || ''
                }
                onChange={handleSelected('kind_of_property')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Basic Rate {validateForm.renderMessage('basic_rate')}
            </label>
            <input
              className="form-control"
              type="number"
              name="basic_rate"
              onChange={onChange}
              value={_.get(formData, 'basic_rate') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Sef Rate {validateForm.renderMessage('sef_rate')}
            </label>
            <input
              className="form-control"
              type="number"
              name="sef_rate"
              onChange={onChange}
              value={_.get(formData, 'sef_rate') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Ordinance Revision{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <div>
              <Select
                options={ordinanceRevisionOptions}
                // styles={customStyle}
                placeholder="Select Ordinance Revision"
                value={
                  ordinanceRevisionOptions.filter(
                    (item) => +ordinanceRevisionId === +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('ordinance_revision_id')}
                isDisabled
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Actual Use {validateForm.renderMessage('actual_use_id')}
            </label>
            <div>
              <Select
                options={actualUseOptions}
                // styles={customStyle}
                placeholder="Select Actual Use"
                value={
                  actualUseOptions.filter(
                    (item) =>
                      +_.get(formData, 'actual_use_id') === +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('actual_use_id')}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

RateModal.defaultProps = {
  type: '',
  updateList: {},
  rateId: '',
};

RateModal.propTypes = {
  type: PropTypes.string,
  rateId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getRateList: PropTypes.instanceOf(Function).isRequired,
  createRate: PropTypes.instanceOf(Function).isRequired,
  updateRate: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleRate: PropTypes.instanceOf(Function).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  actualUseList: _.get(api, `${c.GET_ACTUAL_USES}.list`) || [],
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RateModal);
